import { SpellCheckTextbox } from './SpellCheckTextbox';

/**
 * Hide spellcheck underlines for all textboxes on the canvas during export
 * @param {fabric.Canvas} canvas - The fabric canvas instance
 * @returns {Function} Function to restore spellcheck visibility
 */
export const hideSpellCheckForExport = (canvas) => {
  if (!canvas) {
    canvas = window.canvas;
  }

  if (typeof canvas.getObjects !== 'function') {
    return () => {};
  }

  const restoreFunctions = [];

  // Find all SpellCheckTextbox instances and hide their spellcheck
  canvas.getObjects().forEach((obj) => {
    if (obj instanceof SpellCheckTextbox) {
      const restoreFn = obj.hideSpellCheckForExport();
      restoreFunctions.push(restoreFn);
    }
  });

  // Return a function that restores all spellcheck states
  return () => {
    restoreFunctions.forEach((restore) => restore());
  };
};
